export default __webpack_public_path__ + "static/media/cigarette_smoke.27ebf3bc.png";